export const CLIENT_LEARNOSITY_RECONNECT = 'client:learnosity:reconnect';
export const LEARNOSITY_LAUNCH_FAIL = 'learnosity:launch:fail';
export const LEARNOSITY_LAUNCH_SUCCESS = 'learnosity:launch:success';
export const LEARNOSITY_EMIT_TOOLUSED = 'learnosity:emit:toolused';
export const CLIENT_LEARNOSITY_DISCONNECT = 'client:learnosity:disconnect';
export const PWA_AUTH_CANCEL = 'pwa:auth:cancel';
export const TEST_ABORTED_COMMUNICATION = 'test:aborted:communication';
export const PROCTOR_SAVEANDEXIT = 'pwa:proctor:saveandexit';
export const PROCTOR_SUBMITANDEXIT = 'pwa:proctor:submitandexit';
export const PROCTOR_TERMINATE = 'pwa:proctor:terminate';
export const PROCTOR_PAUSE = 'pwa:proctor:pause';
export const PROCTOR_RESUME = 'pwa:proctor:resume';
export const TESTER_RESUME = 'pwa:tester:resume';
export const TESTER_SAVEANDEXIT = 'pwa:tester:saveandexit';
export const TESTER_SAVEANDEXIT_ERROR = 'pwa:tester:saveandexit:error';
export const PROCTOR_RESUME_CHECK = 'pwa:proctor:resume:check'
export const PROHIBITED_ACTION_PAUSE = 'pwa:prohibitedaction:pause';
export const READY_TO_RESUME = 'pwa:system:readytoresume';
export const AUTH_RECEIVED = 'pwa:system:authreceived';
//actors›
export const ACTOR_TESTER = 'tester';
export const ACTOR_PROCTOR = 'proctor';
export const ACTOR_SYSTEM = 'system';
export const ACTOR_PROCTOR_ENDED= 'proctorEndAction';
export const ACTOR_TESTER_ENDED= 'testerEndAction';
